import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { object, bool } from 'yup';
import { makeStyles } from 'tss-react/mui';
import { useFormik } from 'formik';
import { FormModal } from './FormModal';
import { CheckboxInput } from '../inputs';
import { addResource } from '../../../state';
// import { useRefresh, useNotify } from '../../../hooks';

const initialState = {
  shouldBillCustomer: true,
};

export function RefreshOrderForm({ open, handleClose, orderId }) {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = useCallback(
    async (values) => {
      setSubmitting(true);
      const payload = {
        ...values,
      };
      const { error } = await dispatch(
        addResource({
          baseUrl: `/orders/${orderId}/refresh-wms-order`,
          payload,
          message: 'Items syncing is in progress',
        }),
      );
      setSubmitting(false);
      if (!error) {
        handleClose();
      }
    },
    [orderId, dispatch, handleClose],
  );

  const formik = useFormik({
    initialValues: initialState,
    enableReinitialize: false,
    onSubmit: handleSubmit,
    validationSchema: schema,
  });

  return (
    <FormModal
      open={open}
      handleClose={handleClose}
      title={<span className={classes.title}>Refresh order</span>}
      callback={formik.handleSubmit}
      btnText='SAVE'
      typeSubmit
      paperProps={{ style: { width: 468 } }}
      submitting={submitting}
    >
      <div>
        <CheckboxInput
          formikProps={formik}
          checkboxes={[
            {
              labelProps: {
                label: 'Charge to customer',
              },
              checkboxProps: {
                name: 'shouldBillCustomer',
              },
            },
          ]}
        />
      </div>
    </FormModal>
  );
}

const useStyles = makeStyles()((theme) => ({
  title: {
    fontFamily: 'Montserrat',
    fontSize: 20,
    fontWeight: 600,
  },
}));

const schema = object().shape({
  shouldBillCustomer: bool().typeError('Invalid value').nullable(),
});
